import React from 'react';

import { FormLabel, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getConditionalObject } from 'utils/data';

import RequiredIcon from '../RequiredIcon';

import { labelStyles } from './Label.styles';

const Label = ({ children, required = false, withRequiredIcon = true, name = null }) => (
  <Typography
    data-truncated
    className="label truncate"
    color="text.dark"
    component={FormLabel}
    sx={labelStyles}
    variant="regular14"
    {...getConditionalObject(!!name, () => ({ htmlFor: name }))}
  >
    {children}
    {required && withRequiredIcon && <RequiredIcon />}
  </Typography>
);

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  withRequiredIcon: PropTypes.bool,
};

export default Label;
